import { Box, Card, Typography } from '@bharatpe/bharat-ui';
import React from 'react';
import './styles.scss';
import TimerIcon from 'assets/icons/Autopay/timer.svg';
import TrackDetails from './TrackDetails';
import { useLanguageConfig } from 'Slices/LanguageConfigSlice';
const ComplaintBox: React.FC<any> = ({ complaintDetails }) => {
	const { languageData } = useLanguageConfig();

	const getTransactionStatusClassName = (status: string) => {
		switch (status) {
			case 'CLOSED':
				return 'success-border';
			case 'OPEN':
				return 'primary-border';
		}
	};

	const getTransactionStatusFontColor = (status: string) => {
		switch (status) {
			case 'OPEN':
				return 'primary';
			case 'CLOSED':
				return 'success';
		}
	};

	return (
		<Card className="m4 flex flex-column">
			<Box className="box-border-bottom flex flex-row flex-justify m2 pb5 p2">
				<Box className="flex flex-start w-80 py1">
					<Typography className="Regular300">{languageData.COMPLAINT_STATUS}</Typography>
				</Box>
				<Box
					className={`box-border ml2 secondary-background content-center ${getTransactionStatusClassName(
						complaintDetails?.status,
					)}`}>
					<Typography
						className={`Regular200 uppercase content-center ${getTransactionStatusFontColor(
							complaintDetails?.status,
						)}`}>
						{complaintDetails.status}
					</Typography>
				</Box>
			</Box>
			<Box className="p2">
				<Box className="flex">
					<Box className="flex flex-row m2 pb5">
						<img src={TimerIcon} width={40} height={40} />
						<Typography className="Light100 ml4 py1 grey">{complaintDetails?.dispute_status}</Typography>
					</Box>
				</Box>
			</Box>
			<TrackDetails complaintDetails={complaintDetails} />
		</Card>
	);
};

export default ComplaintBox;
